import React from 'react'
import Title from './Title'
import LinkToGallery from './LinkToGallery'
import IllustrationSection from './Sections/IllustrationSection'
import NFTsection from './NFTsection'
import PopCultureSection from './Sections/PopCultureSection'
import Inktober2020Section from './Sections/Inktober2020Section'
import BlogSection from './Sections/BlogSection'


function HomePage() {
    return (
        <div>
            <Title />
            <LinkToGallery />
            <IllustrationSection />
            <NFTsection />
            <PopCultureSection />
            <Inktober2020Section />
            <BlogSection />
            <LinkToGallery />
        </div>
    )
}

export default HomePage;